import {
    CORP_SECTORS,
    CORP_FEATURES,
    CD_STATES_AND_TERRITORIES,
    MUNI_STATES_AND_TERRITORIES,
    MUNI_PURPOSES,
    TREASURY_TYPES,
    AGENCY_TYPES,
    CORP_DEBT_RANKS,
    MARKET_TYPES,
    MUNI_CATEGORIES,
    MUNI_ENVIRONMENTALS,
    MUNI_DEMINIMIS,
    MUNI_TAXABILITIES,
    COUPON_FREQUENCIES,
    COUPON_MONTHS,
    COUPON_FEATURES,
    CALL_FEATURES,
    PUT_FEATURES,
    OTHER_FEATURES,
    arrayUnique
} from '../../twd/twd'

export const FormFieldArrays = {
    corpSectors: CORP_SECTORS,
    corpFeatures: CORP_FEATURES,
    corpDebtRanks: CORP_DEBT_RANKS,
    corpMarketTypes: MARKET_TYPES,

    muniStates: MUNI_STATES_AND_TERRITORIES,
    muniCategories: MUNI_CATEGORIES,
    muniTaxTreatments: MUNI_TAXABILITIES,
    muniPurposes: MUNI_PURPOSES,
    muniEnvironmentals: MUNI_ENVIRONMENTALS,
    muniDeminimis: MUNI_DEMINIMIS,

    cdBlueSky: CD_STATES_AND_TERRITORIES,
    cdMarketTypes: MARKET_TYPES,

    treasuryTypes: TREASURY_TYPES,
    agencyTypes: AGENCY_TYPES,

    couponFrequencies: COUPON_FREQUENCIES,
    couponPayMonths: COUPON_MONTHS,
    couponFeatures: COUPON_FEATURES,

    callFeatures: CALL_FEATURES,
    putFeatures: PUT_FEATURES,
    otherFeatures: OTHER_FEATURES,
}

export const SearchParamArrays = Object.values(FormFieldArrays)
    .map(arr => arr
        .map(a => a.value.split('=')[0])
        .filter(Boolean))
    .map(arr => arrayUnique(arr))
    .reduce( (x,arr) => [].concat(x, arr))
    .filter(Boolean)
    .concat([
        'holdInsurance',
        'holdFdicNum'
    ])